export const About = () => <h1>Kezdőlap</h1>
export const Contact = () => <h1>Kapcsolat</h1>
export const NotFound = () => <h1>Not Found</h1>